
    <template>
        <component :productId='id'  ref="mainProPage" :is="currentComponent" v-on:getBack="showDetailPage1"></component>
    </template>


  
  <script>
  import School from '../../components/site/School';
  import SchoolSite from '../../components/site/SchoolSite';
  import SiteDetail from '../../components/site/SiteDetail';
  
  export default {
    data() {
      return {
        id:'',
        idSchool:'',
        idSite:'',
        currentComponent : School,
      };
    },
    mounted() {
        this.currentComponent = School;
    },
    methods: {
      showDetailPage1(code){
        console.log('tiaozhuan'+code);
        if(code==='backSite'){
            this.currentComponent = SchoolSite;
            this.id = this.idSchool;
        }else if(code==='backSchool'){
            this.currentComponent = School;
            this.id = this.idSite;
        } else{
            // 
            this.id = code.replace('sch_','');
            if(code.startsWith('sch')){
              this.currentComponent = SchoolSite;
              this.idSchool = code.replace('sch_','');
            }else{
              this.currentComponent = SiteDetail;
              this.idSite = code
            }
        }
      }
    },
    components:{School,SchoolSite,SiteDetail}
  };
  </script>
  
  <style scoped>
  .product-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .product-item {
    flex: 0 0 24%; /* 控制每个商品项的宽度，这里设置为24%，可根据需要调整 */
    margin-bottom: 20px; /* 商品项之间的间距 */
    text-align: center;
  }
  
  .product-image {
    width: 100%;
    height: auto;
    display: block;
    margin-bottom: 10px; /* 图片与商品信息之间的间距 */
  }
  
  .product-info {
    padding: 10px;
  }
  
  .add-to-cart-btn {
    display: block;
    margin: auto;
    padding: 10px;
    background-color: #4CAF50; /* 按钮背景色 */
    color: white; /* 按钮文字颜色 */
    border: none;
    cursor: pointer;
  }
  
  .add-to-cart-btn:hover {
    background-color: #45a049; /* 鼠标悬停时的背景色 */
  }
  </style>